const getMessage = () => "Hello World";
const promoCoupon = "drjnavy";
const promoMinimumTrigger = 120;
const promoProdID = 32317709549671;

Vue.component('cart-wrapper', {
    template: `
        <div class="minicart">
            <div class="minicart__Section" v-if="cart">
                <CartEmpty v-if="cart.item_count === 0" />
                <CartContent v-if="cart.item_count > 0" />
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart'
        ])
    },
    created(){
        var $this = this
        document.addEventListener("_EV.Minicart:add_product", function(e) {
            let productKey = e.detail._id;
            let productProperties = e.detail._properties;
            let ProductsToAdd = {
                properties: productProperties,
                variant:{
                    key: productKey
                },
                amount:1
            }
            $this.addProduct([ProductsToAdd])
            if(e.detail._source){
                $this.setProductAttributes({
                    id: `${ProductsToAdd.variant.key}`, 
                    key: 'line_item_source', 
                    value: `${e.detail._source}`
                })
            }
        });
        document.addEventListener("_EV.Minicart:get", function(e) {
            $this.getCart()
        });
        EvolveCore.PaymentConditions.get()
        $this.getCart()
            .then((cart)=>{
                EvolveCore.GetCheckoutStatus(cart.token).then((checkoutStatus)=>{
                    if(checkoutStatus.isClosed){
                      $this.getCart();
                    }
                })
            });

    },
    methods:{
        ...Vuex.mapActions([
            'getCart',
            'addProduct'
        ]),
        changeToken(){
            this.getCart();
        }

    }
})
//<Bundle :bundles="bundles.bundles" type="default"  v-if="bundles && bundles.bundles.length > 0"/>
Vue.component('CartEmpty', {
    template: `
        <div class="minicart__Empty">
            <div class="minicart__Empty--Header">
                <b @click="closeCart">FECHAR</b>
            </div>
            <div class="minicart__Empty--CTA">
                <img src="https://cdn.shopify.com/s/files/1/1526/6199/files/CartEmptyIcon.gif?v=1644098205">
                <p>
                    <b>Ops,</b> Seu carrinho está vazio.
                </p>
                <span>
                    Descubra os produtos Zissou e redefina a sua relação com o sono
                </span>
            </div>
            
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart',
            'bundles'
        ])
    },
    created(){
        // console.info('SEU CARRINHO ESTÁ VAZIO')
    },
    methods:{
        closeCart(){
            EvolveCore.triggerEvent(`cart:hidden`)
        }
    }
})

// Bundle superior


Vue.component('CartHeader', {
    template: `
        <div class="minicart__Header">
            <el-row>
                <el-col :span="24" class="minicart__Header--Alert" >
                    <span><b>Pronta Entrega e Frete Grátis</b> para todo o brasil</span>
                    <a class="minicart__Header--Close" @click="closeCart"><Icon icon="CloseIcon" /></a>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="ShippingCalculator__Disclaimer" v-if="!ShippingFormVisible">
                    <span class="btn btn-lg btn-block btn-text btn-text--light" @click="ToggleShippingForm">
                        Consulte o CEP +
                    </span>
                </el-col>
            </el-row>
            <el-row class="ShippingCalculator" v-if="ShippingFormVisible">
                <el-col :span="12" class="ShippingCalculator__Wrapper">
                    <Icon icon="svgZissouShipping" />
                    <span>
                        Quer saber <br> quando <b>chega</b>?
                    </span>
                </el-col>
                <el-col :span="12" class="ShippingCalculator__Form">
                    <form @submit.prevent="getShippingRates" v-if=" Shipping.type ==='Brazil' ">
                        <el-input type="text" placeholder="CEP" v-mask="'#####-###'" v-model="Shipping.zip">
                            <el-button slot="append" class="btn btn--secondary" @click="getShippingRates">OK</el-button>
                        </el-input>
                    </form>
                </el-col>
            </el-row>    
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart',
            'bundles',
            'Shipping'
        ])
    },
    data(){
        return{
            ShippingFormVisible: true,
        }
    },
    created() {
        this.GetInventoryIncomings();
    },
    watch: {
        'Shipping.rates': function (newRates, oldRates) {
            if(newRates && newRates.length && JSON.stringify(newRates) !== JSON.stringify(oldRates)){
                this.setShipping({
                    shippingRate: {...newRates[0]}
                })
                this.BuildShippingRates({...newRates[0]})
            }
        }
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'clearCart',
            'setShipping',
            'getZipInfos',
            'BuildShippingRates',
            'GetInventoryIncomings'
            
        ]),
        closeCart(){
            EvolveCore.triggerEvent(`cart:hidden`)
        },
        getShippingRates(){
            this.getZipInfos({'type':this.Shipping.type,'zip':this.Shipping.zip,'country':this.Shipping.country,'province':this.Shipping.province})
        },
        ToggleShippingForm(){
            this.ShippingFormVisible = !this.ShippingFormVisible
        },
    }
})

Vue.component('CartContent', {
    template: `
        <div class="minicart__Content">
            <div class="minicart__Top">
                <CartHeader/>
            </div>

            <div class="minicart__Middle" ref="prodList" v-bind:class="{'overflow': isOverflowing || cart.items.length > 3 }" >
                <perfect-scrollbar ref="prodScroll">
                    <transition name="fade">
                        <ProductArea/>
                    </transition>
                        
                    
                    <transition name="fade">
                        <Bundle :bundles="bundles.bundles" type="default"  v-if="bundles && bundles.bundles.length > 0"/>
                    </transition>
                </perfect-scrollbar>
            </div>
            
            <div class="minicart__Bottom">
                <Totals/>
            </div>
        </div>
    `,
    data(){
        return{
            isOverflowing: false,
        }
    },
    updated(){
        this.setContentHeight();
    },
    computed: {
        ...Vuex.mapGetters([
            'bundles',
            'cart',
            'Coupons',
            'Shipping'
        ]),
        CartTotalDiscounts(){
            let cartTotalDiscount = this.cart.total_discount? parseFloat(this.cart.total_discount / 100) : 0;
            let DiscountsTotalAmount = this.Coupons.appliedDiscounts ? 
                this.Coupons.appliedDiscounts.reduce(function(prev, cur) {
                    return prev + cur.amount / 100;
                }, 0) : 
                0;
            return cartTotalDiscount + DiscountsTotalAmount
        },
        CartTotalPrice(){
            let CartOriginalTotalPrice = this.cart.original_total_price? parseFloat(this.cart.original_total_price / 100) : 0;
            let ShippingPrice = this.Shipping.shippingRate? parseFloat(this.Shipping.shippingRate.price) : 0;
            let CartTotalDiscounts = this.CartTotalDiscounts? parseFloat(this.CartTotalDiscounts) : 0;
            return (CartOriginalTotalPrice + ShippingPrice) - CartTotalDiscounts
        },
    },
    created() {
        this.setContentHeight();
        window.addEventListener("resize", ()=>{
            this.setContentHeight()
        });
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'clearCart'
        ]),
        setContentHeight(){
            var prodList = this.$refs.prodList;
            var prodScroll = this.$refs.prodScroll?this.$refs.prodScroll.$el:null;
            if(prodList && prodScroll){
                prodScroll.style.height = `${prodList.offsetHeight}px`;
            }
            if(prodScroll){

            }
            if(prodList){
                prodScroll.scrollTop = 0;
            }
        }
    }
})

Vue.component('Bundle', {
    template: `
        <div class="minicart__Bundle Recommendation" v-loading="CartState.bundles === 'LOADING'" element-loading-spinner="minicart__LoadingAnimation"  v-show="type !=='mobile'">
            <div class="minicart__Bundle--Inner">
                <div class="minicart__Bundle--Header">
                    Complete sua <b>experiência de sono</b> <br>QUANTO MAIS PRODUTOS, MAIS VOCÊ <b>ECONOMIZA</b>
                </div>
                <div class="minicart__Bundle--Content">
                    <div v-for="bundle in enabledBundles.slice(0,1)" :key="bundle._id" v-bind:class="{'Multiple-Slides': enabledBundles.length > 1}" class="minicart__Bundle--Item">
                        <h4 class="minicart__Bundle__Title">{{bundle.description}}</h4>
                        <swiper :options="swiperOption" ref="mySwiper" class="minicart__Bundle--Products" v-bind:class="{'Multiple-Products': bundles.length === 1}" >
                            <swiper-slide class="minicart__Bundle__Product" v-for="product in enabledBundleProducts(bundle.products)" :key="product._id">
                                <div class="minicart__Bundle__Product--Inner"  @click="setProductsToSelect([product])">
                                    <div class="minicart__Bundle__Product__Title">
                                        <b>{{product.name}}</b>
                                    </div>
                                    <div class="minicart__Bundle__Product--Image">
                                        <div class="minicart__Bundle__Product--Image--Inner">
                                            <img :src="product.image" />
                                        </div>
                                    </div>
                                    <div class="minicart__Bundle__Product--Infos">
                                        <!-- <div class="minicart__Bundle__Product__Discount">
                                            <b>{{product.discountRate * 100}}%</b>
                                        </div> -->
                                        <div class="minicart__Bundle--Actions">
                                            <transition name="fade">
                                                <el-button size="mini" class="btn btn-sm">
                                                    <!-- addBundleProducts(product) -->
                                                    Adicionar 
                                                </el-button>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            </swiper>
                            <div class="swiper-meta">
                                <div class="swiper-button-prev" slot="button-prev">
                                    <Icon icon="ArrowPrev"/>
                                </div>
                                <div class="swiper-button-next" slot="button-next">
                                    <Icon icon="ArrowNext"/>
                                </div>
                            </div>
                    </div>
                </div>
                <transition name="fade">
                    <BundleVariantSelector class="minicart__Bundle--VariantSelector" v-if="ProductsToSelect" :products="ProductsToSelect" @bundle-products-added="setProductsToSelect(null)"/>
                </transition>
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'CartState',
            'cart',
            'Coupons'
        ]),
        swiper() {
            return this.$refs.mySwiper?this.$refs.mySwiper[0].swiper:null
        },
        enabledBundles(){
            let enabledBundles = this.bundles.map((bundle) => {
                bundle.products.map((product) => {
                    product.inventoryQty = product.variants.reduce(function (a, b) {
                        return b['inventoryQty'] == null ? a : a + b['inventoryQty'];
                    }, 0);
                    return product
                })
                bundle.products = bundle.products.filter((product) => {
                    return product
                    // return product.type !== 'Fronha de Travesseiro'
                })
                bundle.inventoryQty = bundle.products.reduce(function (a, b) {
                    return b['inventoryQty'] == null ? a : a + b['inventoryQty'];
                }, 0)
                return bundle
            }).filter((bundle) => {
                return bundle
            });
            enabledBundles = enabledBundles.length > 0 ? enabledBundles.filter((bundle)=>{
                return (bundle.activeVariantsCount === undefined || bundle.activeVariantsCount > 0)
            }):[]
            return enabledBundles
        }
    },
    components: {
	},
    props: ['bundles', 'type'],
    created() {
    },
    mounted() {
        if(this.swiper){this.swiper.update();}
    },
    updated() {
        if(this.swiper){this.swiper.update();}
        this.$nextTick(() => {
            let e = event;
            if (e){
                this.changeHeight(e)
            }
        })
    },
    data(){
        return{
            bundlesFlipped:[],
            ProductsToSelect: null,
            swiperOption: {
                // loop: true,
                simulateTouch: true,
                watchOverflow: true,
                slidesPerView: 3,
                spaceBetween: 10,
                // centeredSlides: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
        }
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'addProduct'
        ]),
        onSetTranslate() {
            this.swiper.update();
        },
        changeHeight(e){
            setTimeout(function() {
                let FlipWrapper = $(e.target).parents('.minicart__Bundle--Content').length > 0 ? $(e.target).parents('.minicart__Bundle--Content') : $(e.target);
                let flipFront = FlipWrapper.find('.Card--Front');
                let flipBack = FlipWrapper.find('.Card--Back');
                let flipHeight = flipBack.outerHeight();
                flipFront.css('min-height', flipHeight>30?flipHeight:'')
            }, 250);
        },
        
        enabledBundleProducts(products){
            return products.length > 0 ? products.filter((product)=>{
                return product.activeVariantsCount === undefined || product.activeVariantsCount > 0
            }):[]
        },
        getBundleVariant(bundleID,prodID,propertiesOBJ){
            delete propertiesOBJ.variantSelected
            let properties = Object.values(propertiesOBJ);
            properties = [properties.join(' / ')]
            let foundBundles = bundle => bundle._id === bundleID
            let GetBundleProducts = bundle => bundle.products
            let foundProducts = product => product._id === prodID
            let GetBundleProductVariants = product => product.variants
            let foundVariants = 
                this.bundles
                    .filter(foundBundles)
                    .map(GetBundleProducts)
                    .flat()
                    .filter(foundProducts)
                    .map(GetBundleProductVariants)
                    .flat();
            let matchedVariants = foundVariants;
            
            for (let i = 0; i < properties.length; i++) {
                const property = properties[i];
                matchedVariants = matchedVariants.filter(
                    // variant => variant.name.indexOf(property) > -1
                    variant => variant.name === property
                )
            }

            return matchedVariants
        },
        getBundleImage(bundleOBJ, type) {
            if (!bundleOBJ){
                return '//cdn.shopify.com/s/files/1/1526/6199/files/produto--banner-principal_767x.jpg';
            }
            var imgURL = bundleOBJ.images.filter(function(item){
                return item.type == type
            })[0].url || '//cdn.shopify.com/s/files/1/1526/6199/files/produto--banner-principal_767x.jpg';
            return imgURL;
        },
        addBundleProducts(selectedBundleProducts){ 
            let addProductOBJNormalized = selectedBundleProducts.map((variantItem)=>{
                let addProductOBJ = {
                    variant: {
                        key: variantItem._id
                    },
                    amount: 1
                }
                return addProductOBJ
            })
            this.addProduct(addProductOBJNormalized);
        },
        setProductsToSelect(ProductsARR){
            this.ProductsToSelect = ProductsARR;
        }
    },
    watch: { 
        bundles: function(newBundle, oldBundle) {
            if(JSON.stringify(newBundle) !== JSON.stringify(oldBundle)){
                this.variantsSelected = {}
                // this.setCartRules(newBundle)
            }
        }
    }
})
Vue.component('BundleVariantSelector', {
    template: `
        <div class="minicart__Bundle--VariantSelector">
            <div class="minicart__Bundle--VariantSelector--Header">
                <a @click="CloseVariantSelector">Fechar</a>
            </div>
            <transition name="fade">
                <div class="minicart__Bundle--VariantSelector--Content"  v-if="BundleGroups && GroupSelectorEnabled">
                    <div class="minicart__Bundle--SelectedProducts GroupSelector">
                        <div v-for="group in BundleGroups">
                            <label>Selecione um <b>modelo de Colchão</b></label>
                            <el-radio-group v-model="group.ProductSelected" @change="hideGroupSelector()">
                                <el-radio-button v-for="product in group.products" :label="product">{{product.name}}</el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <div v-else class="minicart__Bundle--VariantSelector--Content">
                    <div class="minicart__Bundle--SelectedProducts" v-for="product in EnabledProducts" :key="product._id" v-show="product.variants.length > 1">
                        <label>
                            Selecione um tamanho para <b>{{product.name}}</b> 
                            <small v-if="product.source" class="visible-desktop" @click="showGroupSelector()">
                                (Trocar Modelo)
                            </small>
                        </label>
                        <el-select v-model="product.variantSelected" placeholder="Selecione" class="minicart__Bundle--VariantSelector--Select">
                            <el-option
                                v-for="variant in product.variants"
                                :key="variant._id"
                                :label="variant.name"
                                :value="variant._id">
                            </el-option>
                        </el-select>
                        <small v-if="product.source" class="visible-mobile" @click="showGroupSelector()">
                            (Trocar Modelo)
                        </small>
                    </div>
                    <el-button size="mini" class="btn" v-if="variantsSelected.length === EnabledProducts.length" @click="addBundleProducts(variantsSelected)">
                        Adicionar PRODUTOS
                    </el-button>
                </div>
            </transition>
        </div>
    `,
    
    computed: {
        ...Vuex.mapGetters([
            'CartState',
            'cart'
        ]),
        BundleGroups(){
            return this.groups || []
        },
        BundleProducts(){
            return this.products || []
        },
        variantsSelected(){
            return this.EnabledProducts.filter((item)=>{
                return item.variantSelected
            }).map((item)=>{
                return item.variantSelected
            })
        },
        GroupProductsSelected(){
            return this.BundleGroups.filter((item)=>{
                return item.ProductSelected
            }).map((item)=>{
                return item.ProductSelected
            }).map((item)=>{
                item.source = 'group'
                return item
            })
        },
        EnabledProducts(){
            // let prodARR = this.BundleProducts ? this.BundleProducts : this.products;
            let prodARR = [].concat( this.GroupProductsSelected, this.BundleProducts);
            
            return prodARR.filter((product)=>{
                product.variants = product.variants.filter((variant)=>{
                    // return variant.inventoryQty > 0
                    return variant
                })
                // return product.inventoryQty > 0
                return product
            })
        },
    },
    props:['products', 'groups'],
    created() {
        // this.getCart();
        if(this.BundleGroups && !!this.BundleGroups.length){
            this.GroupSelectorEnabled = true;
        }
        if(this.products){
            this.products.map((product)=>{
                if(product.variants.length === 1){
                    product.variantSelected = product.variants[0]._id
                }
                return product
            })
            if(this.variantsSelected.length === this.products.length && !this.BundleGroups.length){
                this.addBundleProducts(this.variantsSelected)
            }
        }
    },
    data() {
        return {
            GroupSelectorEnabled: false
        }
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'clearCart',
            'addProduct'
        ]),
        addBundleProducts(selectedBundleProducts){
            function getOccurrence(array, value) {
                var count = 0;
                array.forEach((v) => (v === value && count++));
                return count;
            }
            let addProductOBJNormalized = selectedBundleProducts.map((variantItem)=>{
                let addProductOBJ = {
                    variant: {
                        key: variantItem
                    },
                    amount: getOccurrence(selectedBundleProducts, variantItem) || 1
                }
                return addProductOBJ
            })
            this.addProduct(addProductOBJNormalized);
            this.CloseVariantSelector()
        },
        CloseVariantSelector(){
            this.products.map((product)=>{
                delete product.variantSelected
                return product
            })
            this.$emit('bundle-products-added');
        },
        hideGroupSelector(){
            this.GroupSelectorEnabled = false
        },
        showGroupSelector(){
            this.GroupSelectorEnabled = true
        }
    }
})
Vue.component('ProductArea', {
    template: `
        <div class="minicart__ProductArea">
            <div class="minicart__ProductItem" v-for="product in cart.items" v-loading="CartState.product === 'LOADING'" element-loading-spinner="minicart__LoadingAnimation" :key="product.key"  v-bind:class="{'hasPromo': product.original_line_price > 0 && product.original_line_price > product.line_price}" >
                <ProductItem :product="product"/>
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'CartState',
            'cart'
        ])
    },
    created() {
        // this.getCart();
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'clearCart'
        ])
    }
})
Vue.component('ProductItem', {
    template: `
        <div class="minicart__ProductItem--Inner">
            <div class="minicart__ProductItem__Data">
                <div class="minicart__ProductItem__Image">
                    <img :src="productItem.image" />
                </div>
                <div class="minicart__ProductItem__Metadata">
                    <div class="minicart__ProductItem__Quantity">
                        <div class="minicart__ProductItem__Quantity__Button--minus" @click="() =>{ if(productItem.line_price > 0){decreaseQty([{'variant':product, 'amount':1}])}  }">
                            <Icon icon="MinusIcon"/>
                        </div>
                        <input type="text" :value="productItem.quantity">
                        <div class="minicart__ProductItem__Quantity__Button--plus" @click="increaseQty([{'variant':product, 'amount':1}])">
                            <Icon icon="PlusIcon"/>
                        </div>
                    </div>
                    <div class="minicart__ProductItem__Prices">
                        <div class="minicart__ProductItem__Price OldPrice" v-if="product.original_line_price > 0 && product.original_line_price > product.line_price">
                            <span class="moneyFormat">{{productItem.original_line_price?$options.filters.formatMoney(productItem.original_line_price/100) : '💤 GRÁTIS'}}</span>
                        </div>
                        <div class="minicart__ProductItem__Price" v-if="productItem.pricing_conditions">
                            <span class="moneyFormat">{{productItem.pricing_conditions.calculated_price?$options.filters.formatMoney(productItem.pricing_conditions.calculated_price/100) : '💤 GRÁTIS'}}</span>
                            <small>
                                {{productItem.pricing_conditions.installment_number === 1 ? 'à vista': productItem.pricing_conditions.installment_number + 'x'}}
                                com {{productItem.pricing_conditions.rate * 100}}% de {{productItem.pricing_conditions.type === 'Discount'? 'desconto': 'juros'}}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="minicart__ProductItem__Infos">
                <div class="minicart__ProductItem__Title">
                    <span>{{productItem.product_title}} <span v-if="productItem.variant_title">{{productItem.variant_title.split('(')[0]}}</span></span> 
                </div>
                <div class="minicart__ProductItem__Variant" v-if="productItem.variant_title">
                    <Icon :icon="'svgZissouRuler'"/>
                    <small>
                        {{$options.filters.remove(productItem.variant_title.split('(')[1], ['(', ')', 'Padrão'])}}
                    </small>
                </div>
                <div class="minicart__ProductItem__Warranty">
                    <i>💤</i>
                    <small>
                        {{getWarrantyConditions(productItem)}}
                    </small>
                </div>
                <div class="minicart__ProductItem__ShippingInfo" v-loading="CartState.shipping === 'LOADING'" element-loading-custom-class="minicart__placeholderLoading">
                    <Icon icon="svgZissouShipping" />
                    <small>
                        {{product.delivery_message? product.delivery_message : 'Frete grátis'}}
                    </small>
                </div>
                <div class="minicart__ProductItem__Discounts" element-loading-custom-class="minicart__placeholderLoading" v-for="(discount, index) in product.discounts" :key="index">
                    <span style="display: flex;">
                        <Icon icon="svgZissouTag" />
                        <small>
                            {{discount.title? discount.title : 'Frete grátis'}}
                        </small>
                    </span>
                </div>
                <div class="minicart__ProductItem__ShippingMode" element-loading-custom-class="minicart__placeholderLoading" v-if="cart.attributes && cart.source === 'pos_evolve'">
                    <span style="display: flex;">
                        <el-switch
                            v-model="productItem.properties._posEvolve_pickupStore"
                            class="el-switch--mini"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch>
                        Retirou na loja?
                    </span>
                </div>
            </div>
        </div>
    `,
    watch: {
        'productItem.properties._posEvolve_pickupStore': function (new_value, old_value) {
            // debugger;
            this.setProductAttributes({
                id: `${this.productItem.key}`, 
                key: 'posEvolve_pickupStore', 
                value: new_value
            })
        }
    },
    computed: {
        ...Vuex.mapGetters([
            'cart',
            'CartState',
            'Coupons',
            'Shipping',
            'InventoryIncomings',
            'Promo_count'
        ]),

        appliedCoupons(){
            return this.Coupons.appliedDiscounts?this.Coupons.appliedDiscounts.map((discount)=>{
                return discount.code
            }) : []
        },
        productItem(){
            let product_item = this.product;
            let paymentCondition = EvolveCore.PaymentConditions.calculatePrice(product_item.line_price)
            product_item.pricing_conditions = paymentCondition;
            return product_item
            // product_item['line_price'] = product_item.id === promoProdID && this.appliedCoupons && this.appliedCoupons.includes(promoCoupon)? product_item.original_line_price - product_item.price:product_item.original_line_price;
        },
    },
    props: ['product'],
    
    created() {
        if(this.product.id === promoProdID){
            console.log(`CheckPrice: ${this.product.handle} ${((this.cart.total_price - this.product.line_price)/100)}`)
            if(((this.cart.total_price - this.product.line_price)/100) < promoMinimumTrigger){
                this.removeProduct([{'variant':{key: this.product.key}, 'amount':0}]).then(()=>{})
            }
        }
    },
    methods: {
        ...Vuex.mapActions([
            'setPromo_count',
            'getCart',
            'increaseQty',
            'decreaseQty',
            'applyCoupon',
            'removeProduct',
            'setProductAttributes',
        ]),
        
        getTranslatedUnitType(unitType){
            switch (unitType.toLowerCase()) {
                case 'day':
                    return 'dia'
                    break;
                case 'days':
                    return 'dias'
                    break;
                case 'month':
                    return 'mês'
                    break;
                case 'months':
                    return 'meses'
                    break;
                case 'year':
                    return 'ano'
                    break;
                case 'years':
                    return 'anos'
                    break;
                default:
                    return unitType
                    break;
            }
        },
        getWarrantyConditions(product) {
            var warranty;
            if (product){
                switch(product.product_type) {
                case 'Toca':
                    warranty = '15 dias de teste'
                    break;
                default:
                    warranty = '100 dias de teste'
                }
            } else {
                warranty = '100 dias de teste'
            }
            return warranty;
        },
    }
})
Vue.component('Totals', {
    template: `
        <div class="minicart__Totals">
        
            <div class="minicart__Totals__Item" v-if="cart.original_total_price < 0">
                <div class="minicart__Totals__Item--Input">
                    <label>Subtotal:</label>
                </div>
                
                <div class="minicart__Totals__Item--Output">
                    <span class="moneyFormat">{{cart.original_total_price?$options.filters.formatMoney(cart.original_total_price/100) : '💪 GRÁTIS'}}</span>
                </div>
            </div>
            <div class="minicart__Totals__Item" v-if="!cart.has_subscription_items && cart.source !== 'pos_evolve' && !DiscountFormVisible">
                <span class="btn btn--lg btn--block btn-text btn-text--light" @click="ToggleDiscountForm">
                    APLICAR CUPOM +
                </span>
            </div>
            <div class="minicart__Totals__Item" v-if="!cart.has_subscription_items && cart.source !== 'pos_evolve' && DiscountFormVisible">
                <div class="minicart__Totals__Item--Input">
                    <label>Cupom:</label>
                    <form @submit.prevent="_applyCoupon(Coupons.code)">
                        <input type="text" v-model="Coupons.code" ref="Coupons.code" placeholder="Insira o código" v-if="!Coupons.status">
                    </form>
                </div>
                
                <div class="minicart__Totals__Item--Output" v-loading="CartState.coupon === 'LOADING'" element-loading-spinner="minicart__placeholderLoading--secondary">
                    <a href="#" class="btn btn--sm" @click="_applyCoupon(Coupons.code)" v-if="!Coupons.status">
                        Aplicar
                    </a>
                    <div class="Coupons__List" v-if="Coupons.status">
                        <span class="Coupons__List--Item" v-for="discount in Coupons.appliedDiscounts">
                            <Icon icon="svgZissouTag" />
                            <span>
                                {{discount.code}}
                            </span>
                            <span @click="_removeCoupon(discount.code)">
                                <Icon icon="CloseIcon" />
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="minicart__Totals__Item " v-if="CartState.coupon === 'ERROR'">
                <div class="minicart__Totals__Item--Output">
                    <el-alert
                        type="error">
                        <span v-html="Coupons.error" slot="title"></span>
                    </el-alert>
                    
                </div>
            </div>
                
            <div class="minicart__Totals__Item"  v-if="CartState.shipping === 'ERROR' && Shipping.type === 'Brazil'">
                <div class="minicart__Totals__Item--ErrorInfo">
                    <p>ooops CEP inexistente :( - Não sabe seu CEP? &nbsp;</p><a href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm" target="_blank">clique aqui</a>
                </div>
            </div>

            <div class="minicart__Totals__Item Main__Info TotalPrice" v-if="Totals && Totals.total  && Totals.total.min.original_price > 0">
                <div class="minicart__Totals__Item--Input">
                    <label>Total:</label>
                </div>
                
                <div class="minicart__Totals__Item--Output">
                    <span class="moneyFormat">
                        {{Totals.total.min.calculated_price?$options.filters.formatMoney(Totals.total.min.calculated_price) : '💤 GRÁTIS'}}
                    </span>
                    <small>
                        {{TotalsMessage}} {{Totals.total.min.installment_number === 1 ? 'à vista': 'em até '+Totals.total.min.installment_number + 'x'}}
                        <span class="text-muted">
                            ou {{Totals.total.max.calculated_price?$options.filters.formatMoney(Totals.total.max.calculated_price) : '💤 GRÁTIS'}}
                            {{Totals.total.max.installment_number === 1 ? 'à vista': 'em até '+Totals.total.max.installment_number + 'x'}}
                            de {{$options.filters.formatMoney(Totals.total.max.installment_price)}} sem juros
                        </span>
                    </small>
                </div>
            </div>
            <div class="minicart__Totals__Item Secondary__Info TotalDiscounts" v-if="TotalDiscounts > 0">
                <div class="minicart__Totals__Item--Input">
                    <label>Você Economiza:</label>
                </div>
                
                <div class="minicart__Totals__Item--Output">
                    <span class="moneyFormat"> {{TotalDiscounts?$options.filters.formatMoney(TotalDiscounts) : '💤 GRÁTIS'}}</span>
                </div>
            </div>
            <div class="minicart__Totals__Item Main__Info" v-if="CartTotalPrice > 0">
                <a :href="CheckoutURL('prod')" class="btn btn-checkout">
                    finalizar compra
                </a>
            </div>
            <div class="minicart__Totals__Item" v-if="CartTotalPrice > 0 && cart.source === 'pos_evolve'">
                <a href="#" class="btn btn-text" @click="clearCartData()">
                    Limpar Carrinho
                </a>
            </div>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'CartState',
            'ShippingTypes',
            'Shipping',
            'cart',
            'Coupons',
            'Totals'
        ]),

        CartTotalDiscounts(){
            let cartTotalDiscount = this.cart.total_discount? parseFloat(this.cart.total_discount / 100) : 0;
            // let paymentConditionDiscount = this.Totals.total.min? this.Totals.total.min.original_price - this.Totals.total.min.calculated_price:0;
            let DiscountsTotalAmount = this.Coupons.appliedDiscounts ? 
                this.Coupons.appliedDiscounts.reduce(function(prev, cur) {
                    return prev + cur.amount / 100;
                }, 0) : 
                0;
            // this.setTotals({discounts: cartTotalDiscount + DiscountsTotalAmount})

            return cartTotalDiscount + DiscountsTotalAmount
        },
        TotalDiscounts(){
            let CartTotalDiscounts = this.CartTotalDiscounts? parseFloat(this.CartTotalDiscounts) : 0;
            let paymentConditionDiscount = this.Totals.total.min? this.Totals.total.min.original_price - this.Totals.total.min.calculated_price:0;
            // this.setTotals({discounts: cartTotalDiscount + DiscountsTotalAmount})

            return CartTotalDiscounts + paymentConditionDiscount
        },
        CartTotalPrice(){
            let CartOriginalTotalPrice = this.cart.original_total_price? parseFloat(this.cart.original_total_price / 100) : 0;
            let ShippingPrice = this.Shipping.shippingRate? parseFloat(this.Shipping.shippingRate.price) : 0;
            let CartTotalDiscounts = this.CartTotalDiscounts? parseFloat(this.CartTotalDiscounts) : 0;
            return (CartOriginalTotalPrice + ShippingPrice) - CartTotalDiscounts
        },
        ShippingRates() {
            let rates = this.Shipping.rates;
            let hasFreeShipping = false;
            let hasShippingCoupon = false;
            if (this.Coupons && this.Coupons.appliedDiscounts){
                hasShippingCoupon = this.Coupons.appliedDiscounts.filter((coupon)=>{
                    return coupon.type === 'shipping'
                }).length > 0
            };
            
            let freeShippingRates = rates.filter((rate)=>{return rate.price === "0.00" });
            
            hasFreeShipping = freeShippingRates.length > 0? true : false;

            rates = hasShippingCoupon ?
                rates.map(rate => {
                    return {
                        ...rate,
                        price: 0
                    }
                }): 
                hasFreeShipping?
                    freeShippingRates :
                    rates
            
            return rates
        },
        ShippingAllCountries() {
            let allCountriesOBJ = this.Shipping.allCountries;
            let blockedcountries = ['Brazil', '---']
            let availableCountries = allCountriesOBJ.filter((country) => {
                return !blockedcountries.includes(country.country)
            })
            return availableCountries.map((countryItem) => {
                return {
                    ...countryItem,
                    name: countryItem.country,
                    provinces: countryItem.provinces.length > 0 ? countryItem.provinces.map((provinceItem) => {
                        return {
                            ...provinceItem,
                            name: provinceItem[0]
                        }
                    }) : null
                }
            })
        },

    
        GetProvinces() {
            let SelectedCountryOBJ = this.ShippingAllCountries.filter( ( country ) => {                 
                return country.country === this.Shipping.country
            } )
            
            return SelectedCountryOBJ[0]? SelectedCountryOBJ[0].provinces : null
        },
        
        appliedCoupons(){
            return this.Coupons.appliedDiscounts?this.Coupons.appliedDiscounts.map((discount)=>{
                return discount.code
            }) : []
        },
        TotalsMessage(){
            let totals_message = "";
            if (this.Totals.total.min.rate === 0){
                totals_message += "sem juros"
            } else {
                totals_message += `com ${(this.Totals.total.min.rate * 100)}%`
                totals_message += " "
            }
            if(this.Totals.total.min.type === 'Discount'){
                totals_message += "de desconto"
            } else {
                totals_message += "de juros"
            }
            return totals_message
        },
    },
    props: ['product'],
    data(){
        return{
            DiscountFormVisible: false,
            GlobalShippingForm: 'OPEN'
        }
    },
    async created() {
        if(this.CartTotalDiscounts){
            this.setTotals({discounts: this.CartTotalDiscounts})
        }
        if(this.CartTotalPrice){    
            this.calculateTotals(this.CartTotalPrice)
        }
        if(this.cart.source === 'pos_evolve' && !window.location.href.includes('view=pos')){
            this.clearCartData()
        }
    },
    updated(){
        if (this.Shipping.type === 'Global' && !this.ShippingRates.length > 0) {
            this.setGlobalShippingForm('CLOSED')
        }
    },
    methods: {
        ...Vuex.mapActions([
            'setPromo_count',
            'setShipping',
            'getCart',
            'getZipInfos',
            'getAppliedCoupon',
            'applyCoupon',
            'removeCoupon',
            'removeProduct',
            'setTotals'
        ]),
        CheckoutURL(env){
            var CheckoutBaseURL = '/checkout/'
            if(env === 'prod'){
                CheckoutBaseURL = `https://checkout.zissou.com.br/Arrival/${this.cart.token}`
            }
            if(env === 'staging'){
                CheckoutBaseURL = `https://evolvehub-checkout--staging.web.app/Arrival/${this.cart.token}`
            }
            if(env === 'dev'){
                CheckoutBaseURL = `https://evolvehub-checkout--staging.web.app/Arrival/${this.cart.token}`
            }
            if(env === 'local'){
                CheckoutBaseURL = `https://localhost:8080/Arrival/${this.cart.token}`
            }
            if(env === 'default'){
                CheckoutBaseURL = `/checkout`
            }
            if(this.cart.source === 'pos_evolve'){
                CheckoutBaseURL = `https://zissou-pos-web.web.app/Arrival/${this.cart.token}`
            }
            return `${CheckoutBaseURL}${this.Coupons.code?`?discount=${this.Coupons.code}`:``}`

        },
        getShippingRates(){
            this.getZipInfos({'type':this.Shipping.type,'zip':this.Shipping.zip,'country':this.Shipping.country,'province':this.Shipping.province})
        },
        setGlobalShippingForm(status){
            this.GlobalShippingForm = status
        },
        ToggleDiscountForm(){
            this.DiscountFormVisible = !this.DiscountFormVisible;
            //this.$refs['Coupons.code'].focus()
        },
        _applyCoupon(discountCode){
            this.applyCoupon(discountCode).then(()=>{
                this.getCart()
            })
        },
        _removeCoupon(discountCode){
            this.removeCoupon()
        },
        clearCartData(){
            EvolveCore.ChangeCartToken();
            setTimeout(() => {
                this.getCart();
            }, 500);
        },
        calculateTotals(totalsValue){
            var _singlePayment = EvolveCore.PaymentConditions.calculatePrice(totalsValue);
            var _installmentPayment = EvolveCore.PaymentConditions.calculatePrice(totalsValue, 'without_addition');    

            this.setTotals({total: {
                min: _singlePayment,
                max: _installmentPayment
            }})       
        }

    },
    watch: {
        'CartTotalDiscounts': function (CartTotalDiscounts, oldRates) {
            this.setTotals({discounts: CartTotalDiscounts})
        },
        'CartTotalPrice': function (CartTotalPrice, oldRates) {
            this.calculateTotals(CartTotalPrice)
        }
    }
})
Vue.component('ShippingLines', {
    template: `
        <div class="ShippingLines__List" >
            <select class="ShippingLines__List-Item" v-model="Shipping.shippingRate">
                <option v-for="(rate, index) in rates" :value="rate" v-bind:selected="index === 0">
                    <span class="moneyFormat">{{rate.title}} - {{rate.shippingPrice > 0 ? $options.filters.formatMoney(rate.shippingPrice) + ' -' : type === 'Brazil'?'GRÁTIS':'💪 FREE'}}</span> {{rate.estimateBusinessDays?rate.estimateBusinessDays+' dias úteis' : ''}}
                </option>
            </select>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart',
            'Shipping',
            'Coupons',
        ]),
    },
    props: ['rates','type'],
    created() {
        this.setShipping({
            shippingRate: this.rates[0]
        })
        this.BuildShippingRates(this.rates[0])
    },
    updated() {
        // console.log('SHIPPINGLINES: updated')
    },
    mounted() {
        // console.log('SHIPPINGLINES: mounted')
    },
    methods: {
        ...Vuex.mapActions([
            'setShipping',
            'getZipInfos',
            'BuildShippingRates'
        ])
    },
    watch: {
        rates: function (newRates, oldRates) {
            if(newRates && newRates.length && JSON.stringify(newRates) !== JSON.stringify(oldRates)){
                this.setShipping({
                    shippingRate: {...newRates[0]}
                })
                this.BuildShippingRates(...newRates[0])
            }
        }
    },
})
Vue.component('Icon', {
    template: `
        <div class="svg---Wrapper">
            <?xml version="1.0" encoding="UTF-8"?>
            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="icon==='MinusIcon'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>btn qty -</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="LineItem" transform="translate(-72.000000, -30.000000)">
                        <g id="CartItem-Inner" transform="translate(12.000000, 9.000000)">
                            <g id="CartItemContent" transform="translate(60.000000, 1.000000)">
                                <g id="qtySelector" transform="translate(1.000000, 17.000000)">
                                    <g id="btn-qty--" transform="translate(0.000000, 4.000000)">
                                        <!-- <circle id="Oval" stroke="#2491c4" cx="9" cy="9" r="9"></circle> -->
                                        <rect id="MinusIcon" fill="#2491c4" x="3" y="8" width="12" height="2"></rect>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="icon==='PlusIcon'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>btn qty +</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="LineItem" transform="translate(-118.000000, -30.000000)">
                        <g id="CartItem-Inner" transform="translate(12.000000, 9.000000)">
                            <g id="CartItemContent" transform="translate(60.000000, 1.000000)">
                                <g id="qtySelector" transform="translate(1.000000, 17.000000)">
                                    <g id="btn-qty-+" transform="translate(46.000000, 4.000000)">
                                        <!-- <circle id="Oval" stroke="#2491c4" cx="9" cy="9" r="9"></circle> -->
                                        <path d="M10,3 L10,8 L15,8 L15,10 L10,10 L10,15 L8,15 L8,10 L3,10 L3,8 L8,8 L8,3 L10,3 Z" id="PlusIcon" fill="#2491c4"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <svg width="154px" height="101px" viewBox="0 0 154 101" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="icon==='CartEmpty'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>EmptyIcon@2x</title>
                <desc>Created with Sketch.</desc>
                <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                    <g id="Desktop/0-Empty" transform="translate(-1182.000000, -249.000000)" stroke="#2491c4">
                        <g id="Cart-Initial" transform="translate(1080.000000, -1.000000)">
                            <g id="CartEmpty" transform="translate(20.000000, 252.000000)">
                                <g id="EmptyIcon" transform="translate(84.000000, 0.000000)">
                                    <line x1="54.8112583" y1="9" x2="41.8112583" y2="58" id="Stroke-3" stroke-width="2" stroke-dasharray="8.252000000000001,8.252000000000001"></line>
                                    <g id="Group-17" transform="translate(0.811258, 0.000000)">
                                        <path d="M44.9361878,70.1861607 L61.3242358,90.6402273 C62.9294017,92.6436007 64.9770131,94.2525073 67.3076594,95.3421407 L67.4566594,95.4126273 C72.1094934,97.5886607 77.5099301,97.5246407 82.1094105,95.238674 C84.1713362,94.2137073 85.9990262,92.778754 87.4779651,91.0204673 L105.25386,69.8977473" id="Stroke-5" stroke-width="2" stroke-dasharray="9.553000000000001,9.553000000000001"></path>
                                        <line x1="106.682308" y1="57.129702" x2="91.3977712" y2="6.04303533" id="Stroke-9" stroke-width="2" stroke-dasharray="8.676,8.676"></line>
                                        <path d="M0,0.565316 L0,23.8155693 C0,29.5224027 2.7470655,34.8845627 7.39079039,38.2407627 L33.9453231,57.434476 C35.1666026,58.3178227 36.2629563,59.3602493 37.2038035,60.534596 L61.3242358,90.6401627 C62.9294017,92.643536 64.9770131,94.2524427 67.3076594,95.342076 L67.4566594,95.4125627 C72.1094934,97.588596 77.5099301,97.524576 82.1094105,95.2386093 C84.1713362,94.2136427 85.9990262,92.7786893 87.4779651,91.0204027 L113.917983,59.601456 C114.746917,58.6165827 115.688415,57.729356 116.722306,56.9585293 L141.424424,38.5453427 C146.193725,34.990616 149,29.4118227 149,23.4870627 L149,0.565316 L0,0.565316 Z" id="Stroke-15" stroke-width="4" stroke-dasharray="9"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            
            <svg viewBox="0 0 14 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="icon==='ArrowNext'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>ArrowNext</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Bundle/Primary" transform="translate(-322.000000, -41.000000)" fill="#2491c4" fill-rule="nonzero">
                        <g id="Bundle">
                            <g id="/ArrowNext" transform="translate(329.000000, 55.000000) rotate(-180.000000) translate(-329.000000, -55.000000) translate(322.000000, 41.000000)">
                                <path d="M13.3581147,27.1252335 C13.2486476,27.1259203 13.1432591,27.0818935 13.0644434,27.0025501 L0.105145814,13.8579039 C-0.0401029378,13.6862234 -0.034194972,13.4266625 0.118700668,13.2623841 C0.271596308,13.0981057 0.519856704,13.084576 0.688293228,13.2313424 L13.6475908,26.3759887 C13.7711134,26.5003251 13.8097063,26.6906791 13.7450379,26.8566327 C13.6803695,27.0225863 13.5254711,27.1306981 13.3539194,27.1296231 L13.3581147,27.1252335 Z" id="Path"></path>
                                <path d="M0.422080574,14.1296231 C0.250528871,14.1306981 0.0956305179,14.0225863 0.0309621069,13.8566327 C-0.0337063041,13.6906791 0.00488659761,13.5003251 0.128409215,13.3759887 L13.0877068,0.231342398 C13.2561433,0.0845759858 13.5044037,0.0981056932 13.6572993,0.262384081 C13.810195,0.426662469 13.8161029,0.686223406 13.6708542,0.857903869 L0.711556628,14.0025501 C0.63445165,14.0824436 0.530683675,14.1279924 0.422080574,14.1296231 Z" id="Path"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            
            <svg viewBox="0 0 14 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  v-if="icon==='ArrowPrev'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>ArrowPrev</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Bundle/Primary" transform="translate(0.000000, -41.000000)" fill="#2491c4" fill-rule="nonzero">
                        <g id="Bundle">
                            <g id="/ArrowPrev" transform="translate(0.000000, 41.000000)">
                                <path d="M13.3581147,27.1114963 C13.2486476,27.1121831 13.1432591,27.0681562 13.0644434,26.9888129 L0.105145814,13.8441666 C-0.0401029378,13.6724862 -0.034194972,13.4129252 0.118700668,13.2486468 C0.271596308,13.0843685 0.519856704,13.0708388 0.688293228,13.2176052 L13.6475908,26.3622514 C13.7711134,26.4865879 13.8097063,26.6769419 13.7450379,26.8428955 C13.6803695,27.0088491 13.5254711,27.1169609 13.3539194,27.1158859 L13.3581147,27.1114963 Z" id="Path"></path>
                                <path d="M0.422080574,14.1158859 C0.250528871,14.1169609 0.0956305179,14.0088491 0.0309621069,13.8428955 C-0.0337063041,13.6769419 0.00488659761,13.4865879 0.128409215,13.3622514 L13.0877068,0.217605166 C13.2561433,0.0708387543 13.5044037,0.0843684618 13.6572993,0.24864685 C13.810195,0.412925238 13.8161029,0.672486175 13.6708542,0.844166638 L0.711556628,13.9888129 C0.63445165,14.0687064 0.530683675,14.1142551 0.422080574,14.1158859 Z" id="Path"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <svg width="9px" height="7px" viewBox="0 0 9 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  v-if="icon==='CloseIcon'">
                <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                <title>CLOSE</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                    <g id="DiscountCoupon" transform="translate(-12.000000, -15.000000)" stroke="#FFF7FA">
                        <g id="Button-Secondary">
                            <g id="CLOSE" style="cursor: pointer;" transform="translate(16.192388, 18.192388) rotate(-315.000000) translate(-16.192388, -18.192388) translate(11.192388, 13.192388)">
                                <path d="M9.93502884,5 L0.935028843,5 M5.43502884,9.5 L5.43502884,0.5" id="Combined-Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <svg viewBox="0 0 27 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  v-if="icon==='svgZissouShipping'">
                <!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
                <title>noun_Shipping_1672175@4x</title>
                <desc>Created with Sketch.</desc>
                <defs></defs>
                <g class="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g class="ShippingTop" transform="translate(-9.000000, -10.000000)">
                        <g class="Titlle">
                            <g transform="translate(9.000000, 4.000000)">
                                <g class="truckIcon" transform="translate(0.000000, 6.000000)">
                                    <path d="M26.9778879,9.2053363 C26.9704888,9.12438237 26.9488166,9.04538691 26.9138793,8.97202401 C26.9068966,8.95802527 26.9138793,8.94169341 26.9010776,8.92769468 L24.60375,5.09087411 C24.2338365,4.47467504 23.5696897,4.09691387 22.8522414,4.09463064 L18.197069,4.09463064 L18.197069,3.39469378 C18.1945033,1.52046709 16.679047,0.00192777758 14.8092672,0 L3.38780172,0 C1.51620587,0.0019314161 -9.91849633e-07,1.52331119 0,3.39936003 L0,16.7693207 C-6.4603495e-16,16.9549555 0.0735681385,17.1329871 0.204520265,17.2642508 C0.335472391,17.3955144 0.513081589,17.4692575 0.698275862,17.4692575 L2.86525862,17.4692575 C3.19195427,18.9477078 4.49971974,20 6.01040948,20 C7.52109922,20 8.82886469,18.9477078 9.15556034,17.4692575 L18.7545259,17.4692575 C19.0841676,18.9433538 20.3896765,19.9911089 21.8967672,19.9911089 C23.403858,19.9911089 24.7093669,18.9433538 25.0390086,17.4692575 L26.3017241,17.4692575 C26.4869184,17.4692575 26.6645276,17.3955144 26.7954797,17.2642508 C26.9264319,17.1329871 27,16.9549555 27,16.7693207 L27,9.30332746 C26.9950664,9.2701588 26.9876752,9.23740449 26.9778879,9.2053363 Z M7.83931034,16.77632 C7.83417786,17.7634455 7.03305004,18.5602256 6.048257,18.5576533 C5.06346397,18.5550809 4.26648978,17.7541265 4.26648978,16.7669875 C4.26648978,15.7798486 5.06346397,14.9788942 6.048257,14.9763218 C7.03305004,14.9737494 7.83417786,15.7705295 7.83931034,16.757655 L7.83931034,16.7681541 L7.83931034,16.77632 Z M16.8005172,4.79456751 L16.8005172,16.0693838 L9.15788793,16.0693838 C8.83316228,14.587811 7.52371679,13.5323137 6.01040948,13.5323137 C4.49710217,13.5323137 3.18765668,14.587811 2.86293103,16.0693838 L1.39655172,16.0693838 L1.39655172,3.39936003 C1.39783434,2.29818431 2.28807539,1.40582564 3.38663793,1.40453997 L14.8139224,1.40453997 C15.912485,1.40582564 16.802726,2.29818431 16.8040086,3.39936003 L16.8005172,4.79456751 Z M18.197069,5.49450437 L22.8522414,5.49450437 C23.079107,5.49529298 23.2891156,5.61469887 23.4062069,5.80947596 L25.0681034,8.5882253 L18.2017241,8.5882253 L18.197069,5.49450437 Z M21.8944397,18.6008221 C20.8874903,18.5969739 20.072689,17.7786708 20.0707759,16.7693207 C20.0714185,15.7566739 20.8907902,14.9362234 21.901034,14.9366528 C22.9112778,14.9370822 23.729955,15.7582289 23.729741,16.7708758 C23.7295269,17.7835228 22.9105025,18.6043216 21.9002586,18.6043218 L21.8944397,18.6008221 Z M25.6034483,16.0693838 L25.0553017,16.0693838 C24.728326,14.5885584 23.4185594,13.5344855 21.9054957,13.5344855 C20.392432,13.5344855 19.0826653,14.5885584 18.7556897,16.0693838 L18.2017241,16.0693838 L18.2017241,9.99276527 L25.6034483,9.99276527 L25.6034483,16.0693838 Z" class="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
                                    <g class="z_salmon_full" transform="translate(3.000000, 5.000000)" fill="#F38480">
                                        <path d="M0.0880722484,3.88831406 L3.98948546,0.0867315886 C4.10816438,-0.0289105295 4.30054915,-0.0289105295 4.41922807,0.0867315886 C5.40113994,1.04230067 6.38305182,1.99908704 7.36496369,2.9558734 C7.60107227,3.18594035 7.98709107,3.18594035 8.22319965,2.9558734 L9.98714312,1.23706634 C10.105822,1.12142422 10.2982068,1.12142422 10.4168857,1.23706634 L11.9109908,2.69293974 C12.0296697,2.80858186 12.0296697,2.99604382 11.9109908,3.11168594 L8.0095776,6.91326841 C7.89089868,7.02891053 7.69851391,7.02891053 7.57983499,6.91326841 L4.63409937,4.04290931 C4.39799079,3.81284236 4.011972,3.81284236 3.77586342,4.04290931 L2.01191994,5.76171637 C1.89324103,5.87735849 1.70085626,5.87735849 1.58217734,5.76171637 L0.0880722484,4.30584297 C-0.0293574161,4.19141814 -0.0293574161,4.00273889 0.0880722484,3.88831406 Z" class="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            
            <svg viewBox="0 0 16 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="icon==='svgZissouRuler'">
                <!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
                <title>Ruler</title>
                <desc>Created with Sketch.</desc>
                <defs></defs>
                <g class="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g class="LineItem" transform="translate(-120.000000, -32.000000)" fill="#425264" fill-rule="nonzero">
                        <g class="CartItem-Inner" transform="translate(13.000000, 9.000000)">
                            <g class="CartItemContent" transform="translate(107.000000, 3.000000)">
                                <g class="Size" transform="translate(0.000000, 17.000000)">
                                    <g class="Ruler" transform="translate(0.000000, 3.000000)">
                                        <path d="M15.0373119,1.35051344e-15 C15.5688861,0 15.9997251,0.421338607 15.9997251,0.941191153 L16,6.05880885 C16,6.57866139 15.569161,7 15.0375868,7 L0.962413248,7 C0.430839002,7 0,6.57866139 0,6.05880885 L2.76192998e-15,0.941191153 C1.38096499e-15,0.421338607 0.430839002,-1.35051344e-15 0.962413248,0 L15.0373119,1.35051344e-15 Z M15,6 L15,1.00013131 L13.633873,1.00013131 L13.633873,2.80401271 L12.8361226,2.80401271 L12.8361226,1.00013131 L11.8888281,1.00013131 L11.8889648,3.90553849 L11.0912144,3.90553849 L11.0912144,1 L10.14392,1 L10.14392,2.8038814 L9.34616962,2.8038814 L9.34616962,1 L8.3988752,1 L8.3988752,3.90553849 L7.6011248,3.90553849 L7.6011248,3.88321647 L7.6012615,1.00013131 L6.65396708,1.00013131 L6.65396708,2.7816907 L5.85621668,2.7816907 L5.85621668,1.00013131 L4.90892226,1.00013131 L4.90892226,3.88334778 L4.11117186,3.88334778 L4.11117186,1.00013131 L3.16387744,1.00013131 L3.16387744,2.7816907 L2.36612705,2.7816907 L2.36612705,1.00013131 L1,1.00013131 L1,6 L15,6 Z" class="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            
            <svg viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="icon==='svgZissouTag'">
                <!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
                <title>zissouIconTag</title>
                <desc>Created with Sketch.</desc>
                <defs></defs>
                <g class="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g class="CartItem/Discount" transform="translate(-11.000000, -71.000000)" fill="#F1655F" fill-rule="nonzero">
                        <g class="zissouIconTag" transform="translate(17.000000, 76.500000) scale(-1, 1) translate(-17.000000, -76.500000) translate(11.000000, 71.000000)">
                            <path d="M6.35658467,10.9999896 C6.19918905,11.0012127 6.05993196,10.893966 6.01485381,10.7368108 C5.96977566,10.5796557 6.0297102,10.4103616 6.16193058,10.3213705 L11.1556929,6.91352203 L7.78640746,1.57677235 C7.71432437,1.46674666 7.7047834,1.32476244 7.76144828,1.20534151 C7.81811316,1.08592059 7.93217517,1.00762727 8.05983461,1.00052613 C8.18749404,0.993424984 8.30890588,1.05861991 8.37744807,1.17107611 L11.9413876,6.81763019 C11.9933967,6.89967896 12.0118106,6.99997403 11.9925386,7.09623481 C11.9732667,7.19249558 11.9179049,7.27675065 11.8387518,7.33028272 L6.53000377,10.9409793 C6.47813901,10.9761038 6.41834621,10.9964499 6.35658467,10.9999896 Z" class="Shape"></path>
                            <path d="M8.94546657,6.09497121 L5.50497348,0.634355165 C5.44830696,0.54322364 5.35559026,0.482995364 5.25194436,0.469988795 L1.44596477,0.00245778967 C1.27343759,-0.0183552066 1.11215791,0.0949477405 1.0664211,0.269096566 L0.01213312,4.18466874 C-0.01405098,4.28554087 0.00257936553,4.39323831 0.0578189323,4.4805282 L3.43154046,9.83521925 C3.5376583,10.0031446 3.75433797,10.0504706 3.91651293,9.94114425 L8.83652348,6.59902807 C8.91529083,6.54720948 8.97102229,6.46498714 8.99145387,6.37045452 C9.01188545,6.2759219 8.99534292,6.17682521 8.94546657,6.09497121 Z M3.05551108,2.98296795 C2.7587015,3.17301412 2.37001398,3.07934465 2.18395726,2.77293296 C1.99790054,2.46652128 2.08380573,2.06154688 2.37658243,1.86485908 C2.66935914,1.66817129 3.05990869,1.75306273 3.2523115,2.05521111 C3.34739862,2.20453543 3.38013958,2.38756218 3.34304587,2.56242941 C3.30595216,2.73729664 3.20219692,2.88904551 3.05551108,2.98296795 Z" class="Shape"></path>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    `,
    computed: {
        ...Vuex.mapGetters([
            'cart'
        ])
    },
    props: ['icon'],
    created() {
        // this.getCart();
    },
    methods: {
        ...Vuex.mapActions([
            'getCart',
            'clearCart'
        ])
    }
})
const minicartStore = new Vuex.Store({
    state: {
        EvolveAPI: {
            BaseURL: 'https://evolvehub.azurewebsites.net/api/',
            AccessToken : sessionStorage.getItem("EvolveToken"),
            Credentials: {
                apiKey: "emlzc291Onppc3NvdWJvbWJhbmRvMjAxOQ",
                password: "YnVkYTpidWRhZXppc3NvdTIwMTk="
            }
        },
        CartState:{
            product: 'IDLE',
            bundles: 'IDLE',
            shipping: 'IDLE',
            coupon: 'IDLE'
        },
        Shipping: {
            allCountries: window.EvolveHUB.ShopifyShippingCountries,
            freeShippingValue: window.EvolveHUB.FreeShippingValue,
            type: 'Brazil',
            zip: null,
            country: null,
            province: null,
            shippingRate: null,
            rates:[]
        },
        InventoryIncomings: null,
        Totals:{
            products: 0,
            shipping: 0,
            discounts: 0,
            total: 0,
        },
        ShippingTypes:[{
          value: 'Brazil',
          label: '🇧🇷'
        },  {
          value: 'Global',
          label: '🌍'
        }],
        cart: null,
        Coupons: {
            code: window.EvolveHUB.ShopifyAutomaticDiscountCoupon || null,
            status:null,
            appliedDiscounts:null,
            nonCumulative: window.EvolveHUB.nonCumulativeCoupons || null
        },
        bundles: null,
        customer: window.EvolveHUB.ShopifyCustomerOBJ || {},
        Promo_count: EvolveStorage.get('promoAppplieanceCount') || 0
    },
    getters: {
        CartState: state => {

            return state.CartState
        },
        cart: state => {
            return state.cart
        },
        Totals: state => {
            return state.Totals
        },
        Coupons: state => {
            return state.Coupons
        },
        customer: state => {
            return state.customer
        },
        bundles: state => {
            return state.bundles
        },
        Shipping: state => {
            return state.Shipping
        },
        ShippingTypes: state => {
            return state.ShippingTypes
        },
        InventoryIncomings: (state) => {
            return state.InventoryIncomings
        },
        Promo_count: state => {
            return state.Promo_count
        }
    },
    actions: {
        async setStorageItem({commit, dispatch, rootState}, payload){
            let $this = this;
            EvolveStorage.set(payload.property, payload.value)
        },
        async deleteStorageItem({commit, dispatch, rootState}, payload){
            let $this = this;
            EvolveStorage.delete(payload.property)
        },
        async Auth({commit, dispatch, rootState}){
            let $this = this;
            await EvolveAPI.post('/AuthApi/Authorize', JSON.stringify(rootState.EvolveAPI.Credentials))
                .then(response => {
                    sessionStorage.setItem("EvolveToken", response.data.data.accessToken)
                    commit('SetAccessToken', response.data.data.accessToken)
                })
                .catch((error) => {
                    console.log('Error Auth')
                });
        },
        
        async getCart({ state, commit, dispatch, rootState }) {
            let Coupons = rootState.Coupons
            commit('setCartState',{product:'LOADING'})
            return new Promise((resolve, reject) => {

                axios.get('/cart.js', {})
                    .then(response => {
                        let cartResponse = response.data;
                        cartResponse.source = cartResponse.attributes._source === 'posEvolve' ? 'pos_evolve' : 'online';
                        if(state.Coupons.code && !!state.Coupons.nonCumulative.find(nonCumulativeCoupon => state.Coupons.code.toLowerCase().includes(nonCumulativeCoupon))){
                            cartResponse.items = cartResponse.items.map(item => {
                                item.line_price = item.original_line_price;
                                item.discounted_price = 0;
                                item.final_price = item.price;
                                item.final_line_price = item.original_line_price;
                                item.discounts = [];
                                item.line_level_discount_allocations = [];
                                return item
                            })
                            cartResponse.total_discount = 0;
                        }
                        // nonCumulative
                        EvolveCore.triggerEvent(`cart:updated`, cartResponse)

                        cartResponse = EvolveCore.setCartValidations(cartResponse)
                        let triggerEvolveFunctions = () =>{
                            if(cartResponse.items.length > 0){
                                dispatch('getBundles')
                            }
                            if(state.Shipping.zip){
                                dispatch('getZipInfos', {'type':state.Shipping.type,'zip':state.Shipping.zip,'country':state.Shipping.country,'province':state.Shipping.province})
                            }
                        }
                        
    
                        if(Coupons.code && cartResponse.items.length > 0){
                            dispatch('applyCoupon', Coupons.code).then(() => {
                                commit('setCart', cartResponse)
                                commit('setCartState',{product:'IDLE'})
                                if(!rootState.EvolveAPI.AccessToken){
                                    dispatch('Auth')
                                        .then(() => {
                                            triggerEvolveFunctions();
                                        })
                                } else {        
                                    triggerEvolveFunctions();
                                }
                            })
                        } else{
                            commit('setCart', cartResponse)
                            commit('setCartState',{product:'IDLE'})
                            if(!rootState.EvolveAPI.AccessToken){
                                dispatch('Auth')
                                    .then(() => {
                                        triggerEvolveFunctions();
                                    })
                            } else {        
                                triggerEvolveFunctions();
                            }
                        }
                        
                        return resolve(cartResponse)
                    })
                    .catch((e) => {
                        console.error(e)
                        commit('setCartState',{product:'IDLE'})
                        console.info('Error getCart')
                        return reject(new Error (`Erro ao recuperar o carrinho.`))
                    })
            })
            
        },
        async getProductDetails({ state, commit, dispatch }) {
            state.cart.items.map((item)=>{
                axios.get(`/products/${item.handle}?view=json`, {})
                    .then(response => {
                        let prodDetails = response.data
                        return commit('setProductDetails', {'handle':item.handle, 'details': prodDetails})
                        // console.log(prodDetails)
                    })
                    .catch((e) => {
                        console.error(e)
                        return commit('setProductDetails', {'handle':item.handle, 'details': {}})
                    })
            })
        },
        async setProductAttributes({ state, commit, dispatch }, {id,key,value}) {
            var product_attributes = {}
            product_attributes.id = id;
            product_attributes.properties = {};
            product_attributes.properties[`_${key}`] = value;
            await axios.post('/cart/change.js', product_attributes)
                .then(response => {
                    dispatch('getCart')
                })
                .catch((e) => {
                    console.error(e)
                    console.info('Error setCartAttribute')
                })
        },

        buildEvolveCartOBJ({ rootState }) {
            let cart = rootState.cart;
            let customer = rootState.customer;
            let EvolveCartOBJ = {};

            EvolveCartOBJ.customer = customer.id ? {
                email: customer.email,
                tags: customer.tags.split(', '),
                ordersCount: parseInt(customer.orders_count),
            }:{
                email: null,
                tags: null,
                ordersCount: 0,
            }
            EvolveCartOBJ.lineItems = cart.items.map((lineItem)=>{
                return {
                    id: lineItem.product_id,
                    variantId: lineItem.id,
                    type:lineItem.product_type,
                    quantity: lineItem.quantity
                }
            });
            EvolveCartOBJ.subTotal = parseFloat(cart.original_total_price / 100) || 0;
            EvolveCartOBJ.totalDiscount = parseFloat(cart.total_discount / 100) || 0;
            EvolveCartOBJ.totalPrice = parseFloat(cart.total_price / 100) || 0;
            
            return EvolveCartOBJ;
        },
        getBundles({ commit, dispatch, state }) {
            commit('setCartState',{bundles:'LOADING'})
            // commit('setBundles', null)
            return new Promise((resolve, reject) => {
                let request = dispatch('buildEvolveCartOBJ').then(EvolveCartOBJ => {
                    EvolveAPI.post('/CartRecommendations', EvolveCartOBJ)
                        .then(response => {
                            let Bundles = response.data
                            // Bundles = bundleMock;
                            let enabledBundles = Bundles ? Object.keys(Bundles).map(type =>{return Bundles[type]}).flat().filter(bundle => bundle.allowAddToCart && bundle.allowAddToCart === true) : []
                            enabledBundles = enabledBundles.map((bundle) => {
                                bundle.products.map((product) => {
                                    product.inventoryQty = product.variants.reduce(function (a, b) {
                                        return b['inventoryQty'] == null ? a : a + b['inventoryQty'];
                                    }, 0);
                                    return product
                                })
                                bundle.products = bundle.products.filter((product) => {
                                    return product
                                })
                                bundle.inventoryQty = bundle.products.reduce(function (a, b) {
                                    return b['inventoryQty'] == null ? a : a + b['inventoryQty'];
                                }, 0)
                                return bundle
                            }).filter((bundle) => {
                                // return bundle.inventoryQty > 0
                                return bundle
                            });
                            enabledBundles = enabledBundles.length > 0 ? enabledBundles.filter((bundle)=>{
                                return (bundle.activeVariantsCount === undefined || bundle.activeVariantsCount > 0)
                            }):[]
                            
                            if(enabledBundles.length > 0){
                                let ProductsToAdd = enabledBundles.map(bundleAllowed => {
                                    return {
                                        variant:{
                                            key: bundleAllowed.products[0].variants[0]._id
                                        },
                                        amount:1
                                    }
                                })
                                dispatch('addProduct', ProductsToAdd)
                            }
                            commit('setBundles', response.data)
                            commit('setCartState',{bundles:'IDLE'})
                        })
                        .catch((e) => {
                            console.error(e)
                            if(e.response.status === 401){
                                dispatch('Auth')
                                    .then(() => {
                                        dispatch('getBundles')
                                    })
                            } else {
                                commit('setCartState',{bundles:'IDLE'})
                                console.info('Error getBundles')
                            }
                        })
                });
            })
        },
        async clearCart({ commit, dispatch }) {
            await axios.get('/cart/clear.js', {})
                .then(response => {
                    dispatch('getCart')
                })
                .catch((e) => {
                    console.error(e)
                    // commit('SetIncomings', null, 'ERROR')
                    console.info('Error clearCart')
                })
        },
        
        async decreaseQty({ commit, dispatch }, lineItemsARR) {
            let changeQtyOBJ = {};
            changeQtyOBJ['lineItems'] = lineItemsARR
            changeQtyOBJ['operation'] = 'subtract'
            dispatch('changeLineItemQty', changeQtyOBJ)
        },
        async increaseQty({ commit, dispatch }, lineItemsARR) {
            let changeQtyOBJ = {};
            changeQtyOBJ['lineItems'] = lineItemsARR
            changeQtyOBJ['operation'] = 'sum'
            dispatch('changeLineItemQty', changeQtyOBJ)
        },
        async addProduct({
            commit,
            dispatch
        }, lineItemsARR) {
            let changeQtyOBJ = {};
            changeQtyOBJ['lineItems'] = lineItemsARR
            changeQtyOBJ['operation'] = 'set'
            dispatch('setLineItemQty', changeQtyOBJ)
        },
        async removeProduct({
            commit,
            dispatch
        }, lineItemsARR) {
            return new Promise((resolve, reject) => {
                let changeQtyOBJ = {};
                changeQtyOBJ['lineItems'] = lineItemsARR
                changeQtyOBJ['operation'] = 'set'
                dispatch('setLineItemQty', changeQtyOBJ).then(() => {
                    resolve()
                })
            });
        },
        async setLineItemQtyToAdd({ commit, dispatch }, changeQtyOBJ) {
            var qtyOBJ = new Object()
            let lineItemsOBJ = changeQtyOBJ.lineItems.map((lineItem)=>{
                qtyOBJ['id'] = lineItem.variant.key
                switch (changeQtyOBJ.operation) {
                    case 'sum':
                        qtyOBJ['quantity'] = lineItem.variant.quantity + lineItem.amount
                        break;
                    case 'subtract':
                        qtyOBJ['quantity'] = lineItem.variant.quantity - lineItem.amount
                        break;
                    default:
                        qtyOBJ['quantity'] = lineItem.amount
                        break;
                }
                return qtyOBJ
            })
            dispatch('addLineItem',lineItemsOBJ)
        },
        async setLineItemQty({ commit, dispatch }, changeQtyOBJ) {
            var qtyOBJ = new Object()
            let lineItemsOBJ = addQtyOBJ.lineItems.map((lineItem) => {
                qtyOBJ['id'] = lineItem.variant.key
                qtyOBJ['properties'] = lineItem.properties
                switch (addQtyOBJ.operation) {
                    case 'sum':
                        qtyOBJ['quantity'] = lineItem.variant.quantity + lineItem.amount
                        break;
                    case 'subtract':
                        qtyOBJ['quantity'] = lineItem.variant.quantity - lineItem.amount
                        break;
                    default:
                        qtyOBJ['quantity'] = lineItem.amount
                        break;
                }
                return qtyOBJ
            })
            dispatch('addLineItem', qtyOBJ)
        },
        async setLineItemQty({
            commit,
            dispatch
        }, changeQtyOBJ) {
            var qtyOBJ = new Object()
            let lineItemsOBJ = changeQtyOBJ.lineItems.map((lineItem) => {
                switch (changeQtyOBJ.operation) {
                    case 'sum':
                        var lineItemNewQty = lineItem.variant.quantity + lineItem.amount
                        qtyOBJ[lineItem.variant.key] = lineItemNewQty
                        break;
                    case 'subtract':
                        var lineItemNewQty = lineItem.variant.quantity - lineItem.amount
                        qtyOBJ[lineItem.variant.key] = lineItemNewQty
                        break;
                    default:
                        qtyOBJ[lineItem.variant.key] = lineItem.amount
                        break;
                }
                return qtyOBJ
            })
            dispatch('updateLineItem', qtyOBJ)
        },
        async changeLineItemQty({
            commit,
            dispatch
        }, changeQtyOBJ) {
            var qtyOBJ = new Object()

            let lineItemsOBJ = changeQtyOBJ.lineItems.map((lineItem) => {
                qtyOBJ['id'] = lineItem.variant.key
                switch (changeQtyOBJ.operation) {
                    case 'sum':
                        var lineItemNewQty = lineItem.variant.quantity + lineItem.amount
                        qtyOBJ['quantity'] = lineItemNewQty
                        break;
                    case 'subtract':
                        var lineItemNewQty = lineItem.variant.quantity - lineItem.amount
                        qtyOBJ['quantity'] = lineItemNewQty
                        break;
                    default:
                        qtyOBJ['quantity'] = lineItem.amount
                        break;
                }
                return qtyOBJ
            })
            dispatch('changeLineItem', qtyOBJ)
        },
        async changeLineItem({
            commit,
            dispatch
        }, updateItemsArray) {
            let request = updateItemsArray
            await axios.post('/cart/change.js', request)
                .then(response => {
                    dispatch('getCart')
                })
                .catch((e) => {
                    console.error(e)
                    console.info('Error updateLineItem')
                })
        },
        async addLineItem({ commit, dispatch }, addItemsArray) {
            try {
                await EvolveCore.Cart.add(addItemsArray)
                return dispatch('getCart')
            } catch (e) {
                console.error(e)
                console.info('Error updateLineItem')
            }
        },
        async updateLineItem({ commit, dispatch }, updateItemsArray) {
            let request = {}
            request.updates = updateItemsArray;
            await axios.post('/cart/update.js', request)
                .then(response => {
                    EvolveCore._helpers.triggerEvent(`Core:product:updated`, response)
                    dispatch('getCart')
                })
                .catch((e) => {
                    console.error(e)
                    console.info('Error updateLineItem')
                })
        },
        // async addLineItem({
        //     commit,
        //     dispatch
        // }, addItemsArray) {
        //     let request = addItemsArray;
        //     // request.adds = addItemsArray;

        //     await axios.post('/cart/add.js', request)
        //         .then(response => {
        //             dispatch('getCart')
        //         })
        //         .catch((e) => {
        //             console.error(e)
        //             console.info('Error addLineItem')
        //         })
        // },
        setShipping({ commit }, infos){
            commit('setShipping',
                {
                    ...infos
                }
            )
        },
        async getZipInfosBrazil ({ commit, dispatch, rootState },zip) {
            zip.length === 8 &&
                await axios.get('https://viacep.com.br/ws/' + zip + '/json/')
                    .then(function (response) {
                        response.data.estado = null
                        switch (response.data.uf) { 
                            case 'AC' : response.data.estado = 'Acre'; break; 
                            case 'AL' : response.data.estado = 'Alagoas'; break; 
                            case 'AP' : response.data.estado = 'Amapá'; break; 
                            case 'AM' : response.data.estado = 'Amazonas'; break; 
                            case 'BA' : response.data.estado = 'Bahia'; break; 
                            case 'CE' : response.data.estado = 'Ceará'; break; 
                            case 'DF' : response.data.estado = 'Distrito Federal'; break; 
                            case 'ES' : response.data.estado = 'Espírito Santo'; break; 
                            case 'GO' : response.data.estado = 'Goiás'; break; 
                            case 'MA' : response.data.estado = 'Maranhão'; break; 
                            case 'MT' : response.data.estado = 'Mato Grosso'; break; 
                            case 'MS' : response.data.estado = 'Mato Grosso do Sul'; break; 
                            case 'MG' : response.data.estado = 'Minas Gerais'; break; 
                            case 'PA' : response.data.estado = 'Pará'; break; 
                            case 'PB' : response.data.estado = 'Paraíba'; break; 
                            case 'PR' : response.data.estado = 'Paraná'; break; 
                            case 'PE' : response.data.estado = 'Pernambuco'; break; 
                            case 'PI' : response.data.estado = 'Piauí'; break; 
                            case 'RJ' : response.data.estado = 'Rio de Janeiro'; break; 
                            case 'RN' : response.data.estado = 'Rio Grande do Norte'; break; 
                            case 'RS' : response.data.estado = 'Rio Grande do Sul'; break; 
                            case 'RO' : response.data.estado = 'Rondônia'; break; 
                            case 'RR' : response.data.estado = 'Roraima'; break; 
                            case 'SC' : response.data.estado = 'Santa Catarina'; break; 
                            case 'SP' : response.data.estado = 'São Paulo'; break; 
                            case 'SE' : response.data.estado = 'Sergipe'; break; 
                            case 'TO' : response.data.estado = 'Tocantins'; break; default : $estado = 'Não informado.'; break; 
                        }
                        commit('setShipping',
                            {
                                'country': 'Brazil',
                                'province': response.data.estado,
                            }
                        )
                        return response.data;
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
                    .finally(function () {})
        },
        async getZipInfosUS ({ commit, dispatch, rootState },zip) {
            zip.length === 5 &&
                await axios.get(`http://api.zippopotam.us/us/${zip}`)
                    .then(function (response) {
                        commit('setShipping',
                            {
                                'country': 'United States',
                                'province': response.data.places[0].state,
                            }
                        )
                        return response.data;
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
                    .finally(function () {})
        },
        getZipInfos ({ commit, dispatch, rootState },payload) {
            const $this = this
            let zip = payload.zip.replace(/\D/g, '')

            commit('setCartState',{shipping:'LOADING'})

            switch (payload.type) {
                    case 'Brazil':
                        dispatch('getZipInfosBrazil', zip)
                            .then(response => {
                                dispatch('getShippingLines', {
                                    zip: rootState.Shipping.zip,
                                    country: rootState.Shipping.country,
                                    province: rootState.Shipping.province
                                })
                            }, (error) => {
                                commit('setCartState',{shipping:'ERROR'})
                                console.info('Erro ao calcular cep, por favor tente novamente :)')
                            })
                    break;
                    case 'United States':
                        dispatch('getZipInfosUS', zip)
                            .then(response => {
                                dispatch('getShippingLines', {
                                    zip: rootState.Shipping.zip,
                                    country: rootState.Shipping.country,
                                    province: rootState.Shipping.province
                                })
                            }, (error) => {
                                console.info('Error at shipping calculation, please try again :)')
                            })
                    break;
                default:
                    dispatch('getShippingLines', {
                        zip: rootState.Shipping.zip,
                        country: rootState.Shipping.country,
                        province: rootState.Shipping.province
                    })
                    break;
            }
        },
        getShippingLines({ rootState, commit, dispatch }, payload) {
            let request = payload;
            let serialize = function(obj, prefix) {
                var str = [],
                    p;
                for (p in obj) {
                    if (obj.hasOwnProperty(p)) {
                    var k = prefix ? prefix + "[" + p + "]" : p,
                        v = obj[p];
                    str.push((v !== null && typeof v === "object") ?
                        serialize(v, k) :
                        encodeURIComponent(k) + "=" + encodeURIComponent(v));
                    }
                }
                return str.join("&");
            }
            commit('setCartState',{shipping:'LOADING'})
            commit('setShipping',{'rates': [], 'error': false})
            
            axios.get('/cart/shipping_rates.json?'+serialize({shipping_address:request}))
                .then(response => {
                    commit('setShipping',   
                        {
                            'rates': response.data.shipping_rates
                        }
                    )
                    commit('setCartState',{shipping:'IDLE'})
                    sessionStorage.setItem('ZipCode', response.data.shipping_rates);
                })
                .catch((e) => {
                    console.error(e)
                    commit('setCartState', {'shipping': 'ERROR'})
                    console.log('Erro ao calcular o frete, verfique seu CEP e tente novamente')
                })
        },
        async GetInventoryIncomings ({ commit, dispatch }) {
            
            return new Promise((resolve, reject) => {
                EvolveAPI.get('/InventoryIncomings').then(response => {
                    commit('SetInventoryIncomings', response.data)
                    resolve(response.data)
                }).catch(err => {
                    reject(new Error(`GetIncomings: ${err.message}`))
                })
            })
            
            
            
        },
        GetInventoryIncoming ({ state, commit, dispatch }, id) {
            return new Promise((resolve, reject) => {
                if(!state.InventoryIncomings){
                    dispatch('GetInventoryIncomings')
                        .then(function(incomings) {
                            return incomings;
                        })
                        .then(function(InventoryIncomings) {
                            var foundInventories = InventoryIncomings.filter(function(incoming){
                                return parseInt(incoming.partnerId) === id;
                            })
                            resolve(foundInventories[0] || null)
                        });
                } else{
                    var foundInventories = state.InventoryIncomings.filter(function(incoming){
                        return parseInt(incoming.partnerId) === id;
                    })
                    resolve(foundInventories[0] || null)
                }
            })
        },
        async BuildShippingRates({ state, commit, dispatch }, methodOBJ){
            let incomings = state.InventoryIncomings;
            let range = methodOBJ.delivery_days;
            let cartProducts = state.cart.items.map((item)=>{
                console.log('dispatch')
                return dispatch('GetInventoryIncoming', item.variant_id).then((incoming)=>{
                    // var sinceDate = incoming ? moment(incoming.incomingDate).format("DD/MMM") : null
                    // var sinceDate = incoming ? moment(incoming.incomingDate).format("DD/MMM") : null
                    var sinceDate = incoming ? EvolveCore._helpers.dateFormat(incoming.incomingDate) : null
                    var minEstimatedDays = range[0] - 2
                    var maxEstimatedDays = range[1] + 0
                    
                    minEstimatedDays = minEstimatedDays > 0 ? minEstimatedDays : 0
                    maxEstimatedDays = maxEstimatedDays > 0 ? maxEstimatedDays : 0

                    var deliveryMessage = `
                        ${minEstimatedDays !== maxEstimatedDays
                        ? `${minEstimatedDays > 0? `De ${minEstimatedDays} a`: 'Até'} ${maxEstimatedDays === 1 ? `${maxEstimatedDays} dia útil` : `${maxEstimatedDays} dias úteis`} `
                        : `Até ${maxEstimatedDays === 1 ? `${maxEstimatedDays} dia útil` : `${maxEstimatedDays} dias úteis`}`} 
                        ${sinceDate ? `a partir de ${sinceDate}` : ``}
                    `
                    commit('setProductDeliveryMessage', {'handle':item.handle, 'delivery_message': deliveryMessage.trim()})
                    return item
                })
            })
            await Promise.all(cartProducts).then(function(productsWithMessage) {
                // commit('setCart', {
                //     items: productsWithMessage
                // })
            })
        },
        readCouponFromCheckout({ state, commit, dispatch }, {checkout, coupon}) {
            let couponToValidate = coupon;
            coupon = coupon?coupon.toLowerCase():null;
            return new Promise((resolve, reject) => {
                const getParents = function (elem) {
                    var parents = [];
                    for ( ; elem && elem !== document; elem = elem.parentNode ) {parents.push(elem);}
                    return parents;
                };
                const parentClasses = (selector) => {
                    return getParents(selector).map((item)=>{return item.className?item.className.split(' '):null}).flat()
                }

                const parser = new DOMParser();
                const htmlDocument = parser.parseFromString(checkout, "text/html");
                let CheckoutInfos = Array.from(htmlDocument.querySelectorAll('script')).filter(function(script){
                    return script.text.indexOf('Shopify = window.Shopify || {}') > -1
                })[0].text
                // let CheckoutOBJ = {}
                // CheckoutOBJ.Checkout = {}
                // var ShopifyKey = new RegExp(/Shopify\b/, 'g');
                // var WindowKey = new RegExp(/window.\b/, 'g');
                // CheckoutInfos = CheckoutInfos.replace(ShopifyKey, 'CheckoutOBJ');
                // CheckoutInfos = CheckoutInfos.replace(WindowKey, '');
                
                var parseCheckoutOBJ = new Function (CheckoutInfos);
                parseCheckoutOBJ()

                if(Shopify.Checkout.page === 'stock_problems'){
                    let productsToRemove = htmlDocument.querySelectorAll('.product__status')[0].parentNode.querySelectorAll('.product__description')[0].innerHTML.trim()
                    commit('setCartState',{coupon:'ERROR'})
                    commit('setCoupons',{
                        error: `O produto ${productsToRemove} está esgotado, remova-o e tente novamente`
                    })
                    console.info(`O produto ${productsToRemove} está esgotado, remova-o e tente novamente`)
                    return resolve()
                }


                const couponDiscountSelector = htmlDocument.querySelectorAll('.reduction-code__text');
                const couponDiscountTarget = couponDiscountSelector[couponDiscountSelector.length-1];
                const hasCoupon = (couponDiscountTarget && parentClasses(couponDiscountTarget).includes('order-summary__section--total-lines')) || (couponDiscountTarget && parentClasses(couponDiscountTarget).includes('order-summary__section--discount')) ? true : false;
                const hasErrorCoupon = htmlDocument.querySelectorAll('#error-for-reduction_code').length > 0 ? true : false;

                let hasPreviousCouponApplied = false;

                let couponDiscountAppliesTo = null;
                let couponDiscountCode = null;
                let couponDiscountType = htmlDocument.querySelectorAll('[data-discount-type]')[0] ? htmlDocument.querySelectorAll('[data-discount-type]')[0].dataset.discountType : null;
                let couponDiscountAmount = htmlDocument.querySelectorAll('[data-checkout-discount-amount-target]')[0] ? parseInt(htmlDocument.querySelectorAll('[data-checkout-discount-amount-target]')[0].dataset.checkoutDiscountAmountTarget) : null;
                
                let lineItemCoupons = htmlDocument.querySelectorAll('.order-summary__section--product-list .reduction-code__text');
                let lineItemCouponsApplied = [];
                for (i = 0; i < lineItemCoupons.length; ++i) {
                    var e = lineItemCoupons[i]
                    lineItemCouponsApplied.push(e.innerText.trim().split('(-')[0].replace(')', '').toLowerCase().trim())
                }
                if(hasCoupon){
                    couponDiscountCode = couponDiscountSelector[couponDiscountSelector.length-1].innerText.trim().toLowerCase();
                    if(lineItemCouponsApplied.length > 0 && lineItemCouponsApplied.indexOf(coupon) > -1)  {
                        couponDiscountAppliesTo = 'line_item';
                        couponDiscountType = 'amount';
                        couponDiscountAmount = 0;
                        _foundCouponAmout = false
                        for (i = 0; i < couponDiscountSelector.length; ++i) {
                            var e = couponDiscountSelector[i]
                            // if(!_foundCouponAmout){
                                if(!!e.innerText.trim().split('(-')[1]){
                                    if(coupon === couponDiscountCode && e.innerText.trim().toLowerCase().indexOf(couponDiscountCode)>-1){
                                        var couponValueFormatted = e.innerText.trim().split('(-')[1].replace(')', '')
                                        var couponValueAmount = parseFloat((minicartStore._vm.$options.filters.unformatMoney(couponValueFormatted)));
                                        couponDiscountAmount += parseFloat((couponValueAmount).toFixed(2));
                                        _foundCouponAmout = true;
                                }
                            }
                        }
                        // couponDiscountAmount = parseFloat((minicartStore._vm.$options.filters.unformatMoney(htmlDocument.querySelectorAll('.order-summary__section--total-lines [data-checkout-subtotal-price-target]')[0].innerText) - minicartStore._vm.$options.filters.unformatMoney(htmlDocument.querySelectorAll('.total-recap .total-recap__final-price')[0].innerText)).toFixed(2)) > 0 ? parseFloat((minicartStore._vm.$options.filters.unformatMoney(htmlDocument.querySelectorAll('.order-summary__section--total-lines [data-checkout-subtotal-price-target]')[0].innerText) - minicartStore._vm.$options.filters.unformatMoney(htmlDocument.querySelectorAll('.total-recap .total-recap__final-price')[0].innerText)).toFixed(2)) : null;
                        console.log(`couponDiscountAmount ${couponDiscountAmount}`)
                    } else if(parentClasses(couponDiscountTarget).includes('order-summary__section--total-lines')) {

                        couponDiscountAppliesTo = 'order';
                        couponDiscountCode = couponDiscountSelector[couponDiscountSelector.length-1].innerText.trim().toLowerCase();
                        couponDiscountType = htmlDocument.querySelectorAll('[data-discount-type]')[0] ? htmlDocument.querySelectorAll('[data-discount-type]')[0].dataset.discountType : null;
                        couponDiscountAmount = htmlDocument.querySelectorAll('[data-checkout-discount-amount-target]')[0] ? parseInt(htmlDocument.querySelectorAll('[data-checkout-discount-amount-target]')[0].dataset.checkoutDiscountAmountTarget) : null;
                    } else {
                        couponDiscountAppliesTo = null;
                        couponDiscountType = null;
                        couponDiscountAmount = null;
                    }
                    hasPreviousCouponApplied =  couponDiscountCode === coupon || htmlDocument.querySelector('[data-step]').getAttribute('data-step') === 'stock_problems'? false : true
                }


                if(hasCoupon && !hasErrorCoupon){
                    if(!hasPreviousCouponApplied){
                        dispatch('setStorageItem', {
                            property: 'discount_coupon',
                            value: couponDiscountCode
                        })

                        if(couponDiscountCode.toLowerCase() === 'inspireoutras'){
                            // debugger;
                            // couponDiscountAmount = 200 * 100
                        }

                        commit('setCoupons',{
                            code: couponDiscountCode,
                            status: hasCoupon,
                            appliedDiscounts:[
                                {
                                    code: couponDiscountCode,
                                    type: couponDiscountType,
                                    amount: couponDiscountAmount,
                                }
                            ],
                        })
                        resolve(couponDiscountCode)
                    } else {
                        if(couponDiscountAppliesTo !== 'line_item'){
                            dispatch('removeCoupon').then(()=>{
                                dispatch('applyCoupon', couponDiscountCode)
                            })
                        }
                    }
                } else {
                    dispatch('deleteStorageItem', {
                        property: 'discount_coupon'
                    })
                    commit('setCoupons',{
                        code: null,
                        status: null,
                        appliedDiscounts: null,
                    })
                    if(coupon && coupon !== " "){
                        console.warn(`O código ${coupon} não é aplicável para seu carrinho.`)
                        commit('setCartState',{coupon:'ERROR'})
                        commit('setCoupons',{
                            error: `O código <b>${coupon}</b> não é aplicável para seu carrinho.`
                        })

                        if(coupon === promoCoupon){
                            // dispatch('removeProduct',[{'variant':{key: promoProdID}, 'amount':0}])
                        }
        
                        return reject(new Error (`O código ${coupon} não é aplicável para seu carrinho.`))
                    } else {
                        commit('setCartState',{coupon:'IDLE'})
                    }
                    return resolve()
                }
                commit('setCartState',{coupon:'IDLE'})
            })
        },
        async removeCoupon({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                dispatch('applyCoupon', " ").then(() => {
                    dispatch('deleteStorageItem', {
                        property: 'discount_coupon'
                    })
                    commit('setCoupons',{
                        code: null,
                        status: null,
                        appliedDiscounts: null,
                    })
                    dispatch('getCart')
                    resolve()
                })
            })
        },
        applyCoupon({ state, commit, dispatch }, coupon) {
            let couponToValidate = coupon;
            commit('setCartState',{coupon:'LOADING'})
            // if(couponToValidate === promoCoupon && state.Promo_count > 0){
            //     return dispatch('setPromo_count', 0).then(()=>{
            //         dispatch('getBundles')
            //     })
            // }
            console.log(`applying coupon: '${couponToValidate}'`)
            return new Promise((resolve, reject) => {
                axios.get(`/checkout?discount=${encodeURI(coupon)}`)
                    .then(response => {
                        dispatch('readCouponFromCheckout',{checkout:response.data, coupon:coupon}).then(()=>{
                            resolve()
                        })
                    })
                    .catch((e) => {
                        console.error(e)    
                    })
                    .finally(()=>{
                        resolve()
                    })
                // if(!state.Coupons.appliedDiscounts || state.Coupons.appliedDiscounts.filter((discount)=>{return discount.code.toLowerCase() === couponToValidate.toLowerCase()}).length === 0){
                // } else {
                //     commit('setCartState',{coupon:'IDLE'})
                //     resolve()
                // }
            })
        },
        getAppliedCoupon({ state, commit, dispatch }, coupon) {
            commit('setCartState',{coupon:'LOADING'})
            return new Promise((resolve, reject) => {
                axios.get(`/checkout`)
                    .then(response => {
                        dispatch('readCouponFromCheckout',{checkout:response.data}).then((coupon)=>{
                            resolve(coupon)
                        })
                    })
                    .catch((e) => {
                        console.error(e)    
                    })
            })
        },
        async setPromo_count({ commit }, value) {
            await commit('setPromo_count', value)
        },
        async setTotals({ commit }, totals) {
            await commit('setTotals', totals)
        },
        async setCart({ commit }, value) {
            await commit('setCart', value)
        },

    },
    mutations: {
        SetAccessToken: function (state, token) {
            state.EvolveAPI.AccessToken = token
        },
        setCartState: function (state, CartStateOBJ) {
            // state.CartState = CartStateOBJ
            state.CartState = {
                ...state.CartState,
                ...CartStateOBJ
            }
        },
        setCart: function (state, CartOBJ) {
            state.cart = {
                ...state.cart,
                ...CartOBJ
            }
        },
        setProductDetails: function (state, ProdOBJ) {
            let updatedProducts = state.cart.items.map(item => {
                if(item.handle === ProdOBJ.handle){
                    return {
                        ...item,
                        product_details: ProdOBJ.details
                    };
                }
                return item;
            })
            state.cart.items = updatedProducts.slice();
        },
        setProductDeliveryMessage: function (state, ProdOBJ) {
            let updatedProducts = state.cart.items.map(item => {
                if(item.handle === ProdOBJ.handle){
                    return {
                        ...item,
                        delivery_message: ProdOBJ.delivery_message
                    };
                }
                return item;
            })
            state.cart.items = updatedProducts.slice();
        },
        setBundles: function (state, BundlesOBJ) {
            state.bundles = BundlesOBJ
        },
        setPromo_count: function (state, value) {
            EvolveStorage.set('promoAppplieanceCount', value >= 0 ? value : state.Promo_count + 1)
            state.Promo_count = value >= 0 ? value : state.Promo_count + 1
        },
        setShipping: function (state, ShippingOBJ) {
            state.Shipping = {
                ...state.Shipping,
                ...ShippingOBJ
            }
        },
        setTotals: function (state, TotalsOBJ) {
            state.Totals = {
                ...state.Totals,
                ...TotalsOBJ
            }
        },
        setCoupons: function (state, CouponsOBJ) {
            state.Coupons = {
                ...state.Coupons,
                ...CouponsOBJ
            }
        },
        SetInventoryIncomings: function (state, InventoryIncomings) {
            state.InventoryIncomings = InventoryIncomings
        }
    }
})
Vue.filter('unformatMoney', function(moneyString){
    return parseInt(moneyString.replace('R$ ', '').replace('.', '').replace(',', ''))
});
Vue.filter('remove', function(value, keys=[], ValueDefault=''){
    var valueString = value
    if(!value){
        return ValueDefault
    }
    if(keys.length > 0){
        keys.map((key)=>{
            let pattern = key.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            let regexKey = new RegExp(pattern, 'g');
            valueString = valueString.replace(regexKey, '')
            return valueString
        })
    }
    return valueString
});
Vue.filter('formatMoney', function (amount, decimalCount = 2, decimal = ',', thousands = '.') {
  try {
    decimalCount = Math.abs(decimalCount)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount

    const negativeSign = amount < 0 ? '-' : ''

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
    let j = (i.length > 3) ? i.length % 3 : 0

    return negativeSign + 'R$ ' + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
  } catch (e) {
    console.error(e)
  }
})

Vue.use(VueMask.VueMaskPlugin);
Vue.use(window.VueAwesomeSwiper)
Vue.use(window.Vue2PerfectScrollbar)

window.minicartApp = new Vue({
    el: '#app-minicart',
    store: minicartStore,
    data() {
        return {
            message: 'Cart v3.1.9'
        }
    }
})